import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import useNotify from "../../unit/useNotify";
import { Typography } from "@mui/material";
import PaperComponent from "../../unit/PaperComponent";

export default function CustomLoanSwitchAchAccountDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const repaymentAccountData = recordProp?.repaymentAccountData;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        label="Smart ACH"
        variant="contained"
        size="medium"
        color="warning"
        sx={{ marginLeft: "10px", width: "175px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="loan-switchach-account-dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Confirm
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">
              Please confirm the account information for receiving loan
              payments. Then use "Modify Loan Terms" to create new payment
              schedule.
            </Typography>
            <TextField
              variant="outlined"
              label="Institution Name"
              value={
                repaymentAccountData?.bankAccount?.sRepyamentInstitutionName
              }
              disabled={true}
            />
            <TextField
              variant="outlined"
              label="Account Type"
              value={repaymentAccountData?.bankAccount?.sRepyamentAccountType}
              disabled={true}
            />
            <TextField
              variant="outlined"
              label="Account Number"
              value={repaymentAccountData?.bankAccount?.sRepyamentAccountNumber}
              disabled={true}
            />
            <TextField
              variant="outlined"
              label="Routing Number"
              value={repaymentAccountData?.bankAccount?.sRepyamentRoutingNumber}
              disabled={true}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
